export default __webpack_public_path__ + "static/media/NesoLogoDarkUranium.0c8f9279.svg";